module.exports = __webpack_public_path__ + "static/media/holly-berry.6dbb3503.svg";